var map = {
	"./east/frame_000.png": 7237,
	"./east/frame_001.png": 4348,
	"./east/frame_002.png": 9175,
	"./east/frame_003.png": 1486,
	"./east/frame_004.png": 7601,
	"./east/frame_005.png": 7656,
	"./north-east/frame_000.png": 9471,
	"./north-east/frame_001.png": 5670,
	"./north-east/frame_002.png": 7437,
	"./north-east/frame_003.png": 7844,
	"./north-east/frame_004.png": 2651,
	"./north-east/frame_005.png": 7458,
	"./north-west/frame_000.png": 4265,
	"./north-west/frame_001.png": 4368,
	"./north-west/frame_002.png": 5659,
	"./north-west/frame_003.png": 4530,
	"./north-west/frame_004.png": 2429,
	"./north-west/frame_005.png": 5748,
	"./north/frame_000.png": 8927,
	"./north/frame_001.png": 5126,
	"./north/frame_002.png": 541,
	"./north/frame_003.png": 7300,
	"./north/frame_004.png": 2107,
	"./north/frame_005.png": 562,
	"./south-east/frame_000.png": 665,
	"./south-east/frame_001.png": 4912,
	"./south-east/frame_002.png": 315,
	"./south-east/frame_003.png": 6658,
	"./south-east/frame_004.png": 1834,
	"./south-east/frame_005.png": 8324,
	"./south-west/frame_000.png": 9103,
	"./south-west/frame_001.png": 2166,
	"./south-west/frame_002.png": 6141,
	"./south-west/frame_003.png": 2244,
	"./south-west/frame_004.png": 6107,
	"./south-west/frame_005.png": 1282,
	"./south/frame_000.png": 9993,
	"./south/frame_001.png": 7888,
	"./south/frame_002.png": 9643,
	"./south/frame_003.png": 5986,
	"./south/frame_004.png": 8781,
	"./south/frame_005.png": 7652,
	"./west/frame_000.png": 5091,
	"./west/frame_001.png": 8906,
	"./west/frame_002.png": 5153,
	"./west/frame_003.png": 6760,
	"./west/frame_004.png": 6375,
	"./west/frame_005.png": 590
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5593;